import { createContext, useContext } from "react";

export interface SelectItem {
  id: number;
  parentId: number | null;
}

type SelectItemTypes = "folders" | "forms" | "files" | "documents";

export type ISelectState = Record<SelectItemTypes, SelectItem[]>;

export interface SelectItemData {
  key: keyof ISelectState;
  item: SelectItem;
}

export type IsSelected = ({ key, id }: { key: keyof ISelectState; id: number }) => boolean;

export interface IImportContext {
  state: ISelectState;
  selectItem: (data: SelectItemData) => void;
  isSelected: IsSelected;
  onSubmit: () => Promise<void>;
  importLoading: boolean;
}

export const ImportContext = createContext<IImportContext>({} as IImportContext);

export const useImportContext = (): IImportContext => useContext(ImportContext);
